import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GenericFieldSpecClass;
function GenericFieldSpec() {
  if (GenericFieldSpecClass === VOID) {
    class $ extends AbstractFieldSpec() {
      constructor(accessor, name, defaultValue, sign) {
        name = name === VOID ? accessor.get_name_woqyms_k$() : name;
        defaultValue = defaultValue === VOID ? null : defaultValue;
        sign = sign === VOID ? null : sign;
        super();
        this.accessor_1 = accessor;
        this.name_1 = name;
        this.defaultValue_1 = defaultValue;
        this.sign_1 = sign;
      }
      get_accessor_3q8qa8_k$() {
        return this.accessor_1;
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      get_defaultValue_6cv1mv_k$() {
        return this.defaultValue_1;
      }
      get_sign_woubd2_k$() {
        return this.sign_1;
      }
    }
    initMetadataForClass($, 'GenericFieldSpec');
    GenericFieldSpecClass = $;
  }
  return GenericFieldSpecClass;
}
var PropertyAccessorClass;
function PropertyAccessor() {
  if (PropertyAccessorClass === VOID) {
    class $ {
      constructor(property, name) {
        name = name === VOID ? property.callableName : name;
        this.property_1 = property;
        this.name_1 = name;
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      trySetWithoutReassigning_of2ay6_k$(container, newValue) {
        var oldValue = this.property_1.get(container);
        var tmp;
        if (oldValue === null) {
          this.property_1.set(container, newValue);
          tmp = null;
        } else if (equals(oldValue, newValue)) {
          tmp = null;
        } else {
          tmp = oldValue;
        }
        return tmp;
      }
      trySetWithoutReassigning_itlg4a_k$(container, newValue) {
        return this.trySetWithoutReassigning_of2ay6_k$(container, newValue);
      }
      getter_8mvnhr_k$(container) {
        return this.property_1.get(container);
      }
    }
    protoOf($).getterNotNull_rjcshh_k$ = getterNotNull;
    initMetadataForClass($, 'PropertyAccessor', VOID, VOID, [Accessor()]);
    PropertyAccessorClass = $;
  }
  return PropertyAccessorClass;
}
var UnsignedFieldSpecClass;
function UnsignedFieldSpec() {
  if (UnsignedFieldSpecClass === VOID) {
    class $ extends AbstractFieldSpec() {
      constructor(accessor, minValue, maxValue, name, defaultValue, sign) {
        name = name === VOID ? accessor.get_name_woqyms_k$() : name;
        defaultValue = defaultValue === VOID ? null : defaultValue;
        sign = sign === VOID ? null : sign;
        super();
        this.accessor_1 = accessor;
        this.minValue_1 = minValue;
        this.maxValue_1 = maxValue;
        this.name_1 = name;
        this.defaultValue_1 = defaultValue;
        this.sign_1 = sign;
        var tmp = this;
        var tmp_0;
        if (this.maxValue_1 < 10) {
          tmp_0 = 1;
        } else if (this.maxValue_1 < 100) {
          tmp_0 = 2;
        } else if (this.maxValue_1 < 1000) {
          tmp_0 = 3;
        } else {
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Max value ' + this.maxValue_1 + ' is too large');
        }
        tmp.maxDigits_1 = tmp_0;
      }
      get_accessor_3q8qa8_k$() {
        return this.accessor_1;
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      get_defaultValue_6cv1mv_k$() {
        return this.defaultValue_1;
      }
      get_sign_woubd2_k$() {
        return this.sign_1;
      }
    }
    initMetadataForClass($, 'UnsignedFieldSpec');
    UnsignedFieldSpecClass = $;
  }
  return UnsignedFieldSpecClass;
}
function getterNotNull(container) {
  var tmp0_elvis_lhs = this.getter_8mvnhr_k$(container);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Field ' + this.get_name_woqyms_k$() + ' is not set');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
var AccessorClass;
function Accessor() {
  if (AccessorClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Accessor');
    AccessorClass = $;
  }
  return AccessorClass;
}
var AbstractFieldSpecClass;
function AbstractFieldSpec() {
  if (AbstractFieldSpecClass === VOID) {
    class $ {
      toString() {
        return 'The field ' + this.get_name_woqyms_k$() + ' (default value is ' + toString(this.get_defaultValue_6cv1mv_k$()) + ')';
      }
    }
    initMetadataForClass($, 'AbstractFieldSpec');
    AbstractFieldSpecClass = $;
  }
  return AbstractFieldSpecClass;
}
function Accessor$getterNotNull$ref(p0) {
  return constructCallableReference((p0_0) => p0.getterNotNull_rjcshh_k$(p0_0), 1, 0, 60, 'getterNotNull', [p0]);
}
function Accessor$getterNotNull$ref_0(p0) {
  return constructCallableReference((p0_0) => p0.getterNotNull_rjcshh_k$(p0_0), 1, 0, 60, 'getterNotNull', [p0]);
}
function Accessor$getterNotNull$ref_1(p0) {
  return constructCallableReference((p0_0) => p0.getterNotNull_rjcshh_k$(p0_0), 1, 0, 60, 'getterNotNull', [p0]);
}
function Accessor$getter$ref(p0) {
  return constructCallableReference((p0_0) => p0.getter_8mvnhr_k$(p0_0), 1, 0, 61, 'getter', [p0]);
}
//region block: exports
export {
  Accessor$getterNotNull$ref_0 as Accessor$getterNotNull$ref2erj3mglm0f6i,
  Accessor$getter$ref as Accessor$getter$ref5gz1lb7u1i2c,
  Accessor$getterNotNull$ref_1 as Accessor$getterNotNull$ref3scn6v6deccs,
  Accessor$getterNotNull$ref as Accessor$getterNotNull$ref2ndsuv51xxzcf,
  GenericFieldSpec as GenericFieldSpecnllvuuqbuxsd,
  PropertyAccessor as PropertyAccessor1m9zk65ebkfc4,
  UnsignedFieldSpec as UnsignedFieldSpec1pqzij1hidkca,
};
//endregion

//# sourceMappingURL=FieldSpec.mjs.map
